import * as React from "react"

import { cn } from "@/lib/utils"

/**
 * Reserva de espacio con barrido, no pulso: comunica "esta llegando" sin el
 * latido ansioso del `animate-pulse` por defecto.
 */
function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("relative overflow-hidden rounded-sm bg-muted", className)}
      {...props}
    >
      <div className="absolute inset-0 -translate-x-full animate-shimmer bg-gradient-to-r from-transparent via-foreground/[0.06] to-transparent" />
    </div>
  )
}

export { Skeleton }
